<script setup>
import { defineProps } from 'vue';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import { ClockIcon, EyeIcon, ChevronRightIcon } from '@heroicons/vue/24/outline';
import BadgeShape from "@/Shared/BadgeShape";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(duration);
function UTCToHumanReadable(u) {
    return dayjs(u).utc().local().tz(dayjs.tz.guess()).format('DD MMM, YYYY');
}

let props = defineProps({
    blog: {
        default: Object
    },
    responsiveChangeStyle: {
        default: true
    }
});
</script>

<template>
    <li class="col-span-1 flex flex-col rounded-2xl bg-wgn-blue-1 p-4" :class="(responsiveChangeStyle)?'hidden sm:block':'block'">
        <div class="flex flex-1 flex-col border-b border-white border-opacity-10 pb-4">
            <Link :href="route('blog.show', blog.slug)" class="relative">
                <BadgeShape type="absolute" class="text-[10px] text-white bg-wgn-purple-3 rounded">{{blog.type_readable}}</BadgeShape>
                <img class="flex-shrink-0 w-full max-h-[210px] object-cover rounded" :src="blog.image_url" :alt="blog.title">
            </Link>
            <Link :href="route('blog.show', blog.slug)">
                <h3 class="mt-4 text-white">{{blog.title}}</h3>
            </Link>
            <dl class="mt-9 flex flex-grow justify-start space-x-6">
                <div>
                    <span class="flex items-center text-sm text-white text-opacity-60"><ClockIcon class="w-4 h-4 mr-1" />{{ UTCToHumanReadable(blog.publish_at) }}</span>
                </div>
                <div>
<!--                    <span class="flex items-center text-sm text-white text-opacity-60"><EyeIcon class="w-4 h-4 mr-1" />{{ blog.view_count }}</span>-->
                </div>
            </dl>
        </div>
        <div class="mx-4 mt-4">
            <Link :href="route('blog.show', blog.slug)" class="-mt-px flex justify-between text-white">
                <span>Read more</span>
                <ChevronRightIcon class="w-4 h-4" />
            </Link>
        </div>
    </li>
    <li class="bg-wgn-blue-1 p-4 rounded" :class="(responsiveChangeStyle)?'block sm:hidden':'hidden'">
        <div class="flex justify-start space-x-4 items-center">
            <div class="flex-shrink-0">
                <Link :href="route('blog.show', blog.slug)">
                    <img class="flex-shrink-0 w-[100px] h-[92px] object-cover rounded" :src="blog.image_url" :alt="blog.title">
                </Link>
            </div>
            <div class="flex flex-col justify-between">
                <BadgeShape type="block" class="text-[10px] text-white bg-wgn-purple-3 w-fit rounded">{{blog.type_readable}}</BadgeShape>
                <Link :href="route('blog.show', blog.slug)">
                    <h3 class="mt-2 text-white">{{blog.title}}{{blog.title}}</h3>
                </Link>
                <dl class="mt-1 flex flex-grow justify-start space-x-6">
                    <div>
                        <span class="flex items-center text-sm text-white text-opacity-60"><ClockIcon class="w-4 h-4 mr-1" />{{ UTCToHumanReadable(blog.publish_at) }}</span>
                    </div>
                    <div>
<!--                        <span class="flex items-center text-sm text-white text-opacity-60"><EyeIcon class="w-4 h-4 mr-1" />{{ blog.view_count }}</span>-->
                    </div>
                </dl>
            </div>
        </div>
    </li>
</template>
